import { useNavigate } from 'react-router-dom'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Button, F0TagStatus } from '@factorialco/f0-react'
import { UpsellLandingPage } from 'generated/resources/datatable.graphql'

import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { useMarketplaceModulesPath } from 'modules/marketplace_modules/hooks/useMarketplaceModulesPath'
import ModulesSection from 'modules/upsell/components/ModulesSection'

const LaunchesWithCEOPageBannerSection = ({
  content,
}: {
  content: UpsellLandingPage | undefined
}) => {
  const navigate = useNavigate()
  const { getListPath } = useMarketplaceModulesPath()

  const section = content?.sections?.at(1)
  return (
    <Box
      style={{
        background:
          'linear-gradient(270deg, rgba(161, 173, 229, 0.12) 0%, rgba(229, 25, 67, 0.12) 50%, rgba(229, 86, 25, 0.12) 100%)',
        paddingBottom: '60px',
      }}
      padding="s80"
      className="flex flex-row items-center justify-between"
    >
      <Box className="flex flex-col gap-4" width="s400">
        {content?.tagLabel && (
          <Box width="fit-content">
            <F0TagStatus text={content?.tagLabel || '-'} variant="warning" />
          </Box>
        )}
        {section?.title && (
          <Text size="500" color="black" weight="bold">
            {section?.title || ''}
          </Text>
        )}
        {section?.description && <Text size="400">{section?.description || ''}</Text>}

        <Box className="flex flex-row gap-2">
          {section?.buttonLabel && (
            <F0Button
              label={section?.buttonLabel || ''}
              onClick={() => {
                track(trackingEvents.upsell.clickExploreMore, {
                  component: 'launches_with_ceo_banner_section',
                })
                navigate(getListPath('upsell_origin=launches_with_ceo'))
              }}
            />
          )}
        </Box>
      </Box>
      <Box style={{ width: '500px' }}>
        <ModulesSection origin="launches_with_ceo" />
      </Box>
    </Box>
  )
}

export default LaunchesWithCEOPageBannerSection
